import * as React from 'react'

import { Dialog, DialogContent } from '@/components/ui/dialog'

interface Props {
	onClose: () => void
	/**
	 * Note: This prop is kept for API compatibility.
	 * In this implementation, it is called immediately on close,
	 * not after the exit animation is complete.
	 */
	onExited?: () => void
	isOpen: boolean
	children: React.ReactNode
}

const AstaModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onExited,
	children,
}) => {
	const handleOpenChange = (open: boolean) => {
		// `onOpenChange` fires when the dialog's open state is requested to change.
		// We only trigger our callbacks when it's closing.
		if (!open) {
			onClose()
			onExited?.()
		}
	}

	return (
		<Dialog open={isOpen} onOpenChange={handleOpenChange}>
			<DialogContent className="text-foreground">
				{children}
			</DialogContent>
		</Dialog>
	)
}

export default AstaModal
